// extracted by mini-css-extract-plugin
module.exports = {"productCellContainer":"orderItemsTable_productCellContainer__2zQDL","itemImage":"orderItemsTable_itemImage__1ejsl"};